import {Tag} from "antd";
import React from "react";
import ResultTable from "../../components/table/ResultTable";
import ResultHeader from "../../components/table/ResultHeader";
import ResultBody from "../../components/table/ResultBody";
import ResultRow from "../../components/table/ResultRow";
import ResultBodyCell from "../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";


export default function MessageSelectedCheck({dataSource}) {

    return (
        <>
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'start'}}>Folder</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start'}}>Project</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start'}}>Plan</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'start'}}>River</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        dataSource.map(record => {
                            return (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125,}}>
                                        {record?.selection?.base?.project?.information?.folderName}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125,}}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Tag>{record?.selection?.base?.project?.modelType}</Tag>
                                            <span>{record?.selection?.base?.project?.information?.title?.trim()}</span>
                                        </div>
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125}}>
                                        {record?.selection?.base?.plan?.type}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', minWidth: 125}}>
                                        <div>
                                            {(record?.selection?.base?.river?.river) && (
                                                <>
                                                    {record?.selection?.base?.river?.river} - {record?.selection?.base?.river?.reach}
                                                </>
                                            )}
                                            {!(record?.selection?.base?.river?.river) && (
                                                <>
                                                    -
                                                </>
                                            )}
                                        </div>
                                    </ResultBodyCell>
                                </ResultRow>
                            )
                        })
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}